module.exports = __webpack_public_path__ + "static/android-chrome-192x192-9bf8e35be0be6f80f7e30969a347174b.png";